// @flow

import React from "react";

import { LinkedFieldValues } from "./styles";
import { FieldValue as NewValue } from "./Values/styles";
import LinkedRoom from "src/components/messages/Chat/Notification/LinkedRoom";
import { getChecklistNotificationDiff } from "src/utils";

import type { RoomId } from "src/types";

type Props = {
  oldValue: Array<RoomId>,
  newValue: Array<RoomId>,
  disableTitleHyperlink: boolean,
};

const ConversationDiffValue = ({
  newValue,
  oldValue,
  disableTitleHyperlink,
}: Props) => {
  const diff = getChecklistNotificationDiff(newValue, oldValue || []);

  return (
    <>
      {diff.length > 0 && (
        <NewValue>
          <LinkedFieldValues>
            {diff.map((val, id) => (
              <LinkedRoom
                id={`${val}`}
                key={id}
                disableTitleHyperlink={disableTitleHyperlink}
              />
            ))}
          </LinkedFieldValues>
        </NewValue>
      )}
    </>
  );
};

export default ConversationDiffValue;
